import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.054 5.1a2.633 2.633 0 11-5.266 0 2.633 2.633 0 015.266 0zm-7.719 5.174A5.467 5.467 0 016.91 7.8h1.098c.805 0 1.585.177 2.292.504-.24.074-.488.144-.68.196a.86.86 0 00-.415.256A4.664 4.664 0 008.008 8.6H6.91a4.667 4.667 0 00-3.905 2.112l-.395.604a.455.455 0 00.326.704c.889.1 2.463.247 4.014.247.72 0 1.532-.032 2.312-.076l.052.065c.179.213.414.398.651.552.068.044.138.087.208.128-1.027.07-2.21.13-3.223.13-1.594 0-3.202-.15-4.103-.25-.948-.107-1.412-1.167-.907-1.939l.395-.603zM9.255 5.1a1.833 1.833 0 11-3.667 0 1.833 1.833 0 013.666 0z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.268 7.945a.911.911 0 01.739 0c.155.069.398.17.696.27.31.106.685.212.952.285.37.1.633.436.633.825v2.126c0 .32-.148.592-.327.805-.179.213-.414.397-.651.552a7.545 7.545 0 01-1.381.675.822.822 0 01-.583 0 7.543 7.543 0 01-1.38-.675 2.953 2.953 0 01-.652-.552c-.179-.213-.327-.485-.327-.806v-.57h.8v.57c0 .065.03.16.14.291.108.13.272.264.475.396a6.76 6.76 0 001.236.6c.002 0 .005 0 .008-.002a6.76 6.76 0 001.227-.598c.203-.132.367-.266.475-.396.11-.13.14-.226.14-.29V9.325a.057.057 0 00-.044-.053 18.471 18.471 0 01-.997-.299 9.09 9.09 0 01-.765-.297.112.112 0 00-.09 0 9.09 9.09 0 01-.764.297c-.334.113-.726.225-.998.299a.057.057 0 00-.043.053v1.554h-.8V9.326c0-.39.263-.725.633-.825.267-.073.641-.18.952-.284.298-.101.54-.202.696-.271z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M10.72 10.934l.573.572a.133.133 0 00.189 0l1.239-1.24",
    stroke: color !== null && color !== void 0 ? color : '#000',
    strokeOpacity: 0.87,
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }));
}
export default SvgComponent;